import { CertificationProviderSearchInterface } from '../interfaces/certification-provider-search.interface';

export class CertificationProviderTeamMemberDownloadCommand {
    statuses: number[];
    certifications_ids: number[];
    certification_providers_ids: number[];
    issue_date_from: string;
    issue_date_to: string;
    expiration_date_from: string;
    expiration_date_to: string;
    show_expiring_only: boolean;
    show_recently_expired_only: boolean;
    user_id: number;
    teams_ids: number[];
    excluded_teams_ids: number[];
    include_subteams_of_teams_in_filter: boolean;

    constructor(query: CertificationProviderSearchInterface, userId: string) {
        this.statuses = query?.statuses || [];
        this.certifications_ids = query?.certificationsIds?.map((id) => parseInt(id)) || [];
        this.certification_providers_ids = query?.certificationProvidersIds?.map((id) => parseInt(id)) || [];
        this.issue_date_from = query?.issueDateFrom ? query.issueDateFrom.format() : null;
        this.issue_date_to = query?.issueDateTo ? query.issueDateTo.format() : null;
        this.expiration_date_from = query?.expirationDateFrom ? query.expirationDateFrom.format() : null;
        this.expiration_date_to = query?.expirationDateTo ? query.expirationDateTo.format() : null;
        this.show_expiring_only = query?.showExpiringOnly ?? false;
        this.show_recently_expired_only = query?.showRecentlyExpiredOnly ?? false;
        this.user_id = parseInt(userId);
        this.teams_ids = query?.teamsIds?.map((id) => parseInt(id)) || [];
        this.excluded_teams_ids = query?.excludedTeamIds?.map((id) => parseInt(id)) || [];
        this.include_subteams_of_teams_in_filter = true;
    }
}
